import { createAction } from '@reduxjs/toolkit';

export const GET_PAGINATED_SUBSCRIPTIONS = 'GET_PAGINATED_SUBSCRIPTIONS';
export const GETTING_PAGINATED_SUBSCRIPTIONS_SUCCEEDED =
  'GETTING_PAGINATED_SUBSCRIPTIONS_SUCCEEDED';
export const GETTING_PAGINATED_SUBSCRIPTIONS_FAILED =
  'GETTING_PAGINATED_SUBSCRIPTIONS_FAILED';

export const UPDATE_CURRENT_EDIT = 'UPDATE_CURRENT_EDIT';

export const UPDATE_RESUBSCRIBE = 'UPDATE_RESUBSCRIBE';
export const UPDATE_RESUBSCRIBE_SUCCEEDED = 'UPDATE_RESUBSCRIBE_SUCCEEDED';
export const UPDATE_RESUBSCRIBE_FAILED = 'UPDATE_RESUBSCRIBE_FAILED';

export const CLEAR_SUBSCRIPTION_STORE = 'CLEAR_SUBSCRIPTION_STORE';

export const UPDATE_UNSUBSCRIBE_FILTERS = 'UPDATE_UNSUBSCRIBE_FILTERS';
export const RESET_UNSUBSCRIBE_FILTERS = 'RESET_UNSUBSCRIBE_FILTERS';

export const GET_UNSUBSCRIBE_COUNT = 'GET_UNSUBSCRIBE_COUNT';
export const GET_UNSUBSCRIBE_COUNT_SUCCEEDED = 'GET_UNSUBSCRIBE_COUNT_SUCCEEDED';
export const GET_UNSUBSCRIBE_COUNT_FAILED = 'GET_UNSUBSCRIBE_COUNT_FAILED';

export const getPaginatedSubscriptions = createAction(GET_PAGINATED_SUBSCRIPTIONS);
export const gettingPaginatedSubscriptionsSucceeded = createAction(
  GETTING_PAGINATED_SUBSCRIPTIONS_SUCCEEDED
);
export const gettingPaginatedSubscriptionsFailed = createAction(
  GETTING_PAGINATED_SUBSCRIPTIONS_FAILED
);

export const updateCurrentEdit = createAction(UPDATE_CURRENT_EDIT);

export const updateResubscribe = createAction(UPDATE_RESUBSCRIBE);
export const updateResubscribeSucceeded = createAction(UPDATE_RESUBSCRIBE_SUCCEEDED);
export const updateResubscribeFailed = createAction(UPDATE_RESUBSCRIBE_FAILED);

export const clearSubscriptionStore = createAction(CLEAR_SUBSCRIPTION_STORE);

export const updateUnsubscribeFilters = createAction(UPDATE_UNSUBSCRIBE_FILTERS);
export const resetUnsubscribeFilters = createAction(RESET_UNSUBSCRIBE_FILTERS);

export const getUnsubscribeCount = createAction(GET_UNSUBSCRIBE_COUNT);
export const getUnsubscribeCountSucceeded = createAction(GET_UNSUBSCRIBE_COUNT_SUCCEEDED);
export const getUnsubscribeCountFailed = createAction(GET_UNSUBSCRIBE_COUNT_FAILED);